<template>
  <top-bar-menu
    :title="$t('common.exploitation')"
    :links="links"
    content-class="top-bar-menu__content"
  />
</template>

<script>
import { computed } from 'vue';

import { ROUTES_NAMES, USER_PERMISSIONS, GROUPED_USER_PERMISSIONS } from '@/constants';

import TopBarMenu from './top-bar-menu.vue';

export default {
  components: { TopBarMenu },
  setup() {
    const links = computed(() => [
      {
        route: { name: ROUTES_NAMES.exploitationDynamicInfos },
        icon: 'assignment',
        permission: USER_PERMISSIONS.technical.exploitation.dynamicInfo,
      },
      {
        route: { name: ROUTES_NAMES.exploitationEventFilters },
        icon: 'policy',
        permission: USER_PERMISSIONS.technical.exploitation.eventFilter,
      },
      {
        route: { name: ROUTES_NAMES.exploitationMetaAlarmRules },
        icon: 'insights',
        permission: USER_PERMISSIONS.technical.exploitation.metaAlarmRule,
      },
      {
        route: { name: ROUTES_NAMES.exploitationPbehaviors },
        icon: 'pause',
        permission: USER_PERMISSIONS.technical.exploitation.pbehavior,
      },
      {
        route: { name: ROUTES_NAMES.exploitationScenarios },
        icon: 'manufacturing',
        permission: USER_PERMISSIONS.technical.exploitation.scenario,
      },
      {
        route: { name: ROUTES_NAMES.exploitationSnmpRules },
        icon: 'approval',
        permission: USER_PERMISSIONS.technical.exploitation.snmpRule,
      },
      {
        route: { name: ROUTES_NAMES.exploitationIdleRules },
        icon: 'published_with_changes',
        permission: USER_PERMISSIONS.technical.exploitation.idleRules,
      },
      {
        route: { name: ROUTES_NAMES.exploitationFlappingRules },
        icon: 'swap_vert',
        permission: USER_PERMISSIONS.technical.exploitation.flappingRules,
      },
      {
        route: { name: ROUTES_NAMES.exploitationResolveRules },
        icon: 'done_all',
        permission: USER_PERMISSIONS.technical.exploitation.resolveRules,
      },
      {
        route: { name: ROUTES_NAMES.exploitationDeclareTicketRules },
        icon: 'local_play',
        permission: USER_PERMISSIONS.technical.exploitation.declareTicketRule,
      },
      {
        route: { name: ROUTES_NAMES.exploitationLinkRules },
        icon: 'link',
        permission: USER_PERMISSIONS.technical.exploitation.linkRule,
      },
      {
        route: { name: ROUTES_NAMES.exploitationRemediation },
        icon: 'assignment',
        permission: GROUPED_USER_PERMISSIONS.remediation,
      },
    ]);

    return {
      links,
    };
  },
};
</script>
